import {getMethod, postMethod} from '~/api'

async function get(ticketId, request) {
    return await getMethod(`/api/tickets/${ticketId}/messages`, request)
}

async function post(ticketId, body) {
    return await postMethod(`/api/tickets/${ticketId}/messages`, body)
}

export {get, post}
